import { render, staticRenderFns } from "./balanceDialog.vue?vue&type=template&id=593c5254&scoped=true&"
import script from "./balanceDialog.vue?vue&type=script&lang=js&"
export * from "./balanceDialog.vue?vue&type=script&lang=js&"
import style0 from "./balanceDialog.vue?vue&type=style&index=0&id=593c5254&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593c5254",
  null
  
)

export default component.exports